import Colors from "assets/Colors";
import { convertCurrencyStringToNumber } from "helpers/hooks";
import Loading from "components/common/loading";
import { useTranslation } from "react-i18next";
import s from "./styles";
import AlertIcon from "components/icons/AlertIcon";
import BarChartStacked from "components/common/BarChartStacked";

function MoneyLine({ color, text, money, last }) {
  return (
    <s.MoneyLine last={last}>
      <s.ContainerColorPaymentType>
        <s.RoundColor style={{ background: color }} />
        <s.PaymentTypeText>{text}</s.PaymentTypeText>
      </s.ContainerColorPaymentType>
      <s.Money>{money || 0}</s.Money>
    </s.MoneyLine>
  );
}

function StackedBarChart({ tableValues, noData, loading, firstGraph }) {
  const { t } = useTranslation();

  const color = [
    `${Colors.primary_web_color1}`,
    `${Colors.primary_web_color1}90`,
    `${Colors.primary_web_color1}70`,
    `${Colors.primary_web_color1}50`,
    `${Colors.primary_web_color1}30`,
  ];

  return (
    <s.Container ref={firstGraph}>
      <s.HeaderContainer>
        <s.Title>{t("general.paymentMethod")}</s.Title>
      </s.HeaderContainer>

      {loading ? (
        <Loading height="260px" size="middle" />
      ) : noData ? (
        <s.NoItemsContainer>
          <s.NoItemsMessageCenter>
            <AlertIcon style={{ display: "block", marginBottom: "7px" }} />
            {t("general.noData")}
          </s.NoItemsMessageCenter>
        </s.NoItemsContainer>
      ) : (
        <s.BodyContainer>
          <s.body>
            <s.LeftBodyContainer>
              {tableValues.map((item, index) => (
                <MoneyLine
                  key={index}
                  color={color[index]}
                  text={item[0]}
                  money={item[4]}
                  last={index === tableValues.length - 1}
                />
              ))}
            </s.LeftBodyContainer>
          </s.body>
          <s.StackedBarChartContainer>
            <BarChartStacked
              showTicksX={false}
              data={{
                columns: tableValues.map((v) => v[0]),
                types: [
                  {
                    data: tableValues.map((v) =>
                      convertCurrencyStringToNumber(v[4])
                    ),
                    backgroundColor: tableValues.map((v, i) => color[i]),
                  },
                ],
              }}
            />
          </s.StackedBarChartContainer>
        </s.BodyContainer>
      )}
    </s.Container>
  );
}

export default StackedBarChart;
